import { render, staticRenderFns } from "./ExpensesList.vue?vue&type=template&id=33c3ecfc&scoped=true"
import script from "./ExpensesList.vue?vue&type=script&lang=js"
export * from "./ExpensesList.vue?vue&type=script&lang=js"
import style0 from "./ExpensesList.vue?vue&type=style&index=0&id=33c3ecfc&prod&lang=scss&scoped=true"
import style1 from "./ExpensesList.vue?vue&type=style&index=1&id=33c3ecfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c3ecfc",
  null
  
)

export default component.exports